<template>
  <b-container class="mt-5">
    <b-card
      class="text-center"
      style="min-height: 560px;"
    >
      <!-- <h3 class="mb-2">
        از ثبت نام شما ممنونیم!
      </h3> -->
      <p
        v-if="!end"
        style="font-weight: bold;"
      >
        جهت ارائه مشاوره بهتر درباره بازارهای مالی و معاملات آنلاین لطفا به سوال زیر پاسخ دهید:
      </p>
      <br>
      <!-- {{ userAnswers }} -->
      <transition
        name="slide-fade"
        mode="out-in"
      >
        <div v-show="!change">
          <h4 v-if="!end">
            {{ currentQuestion.question }}
          </h4>
          <span v-if="!end">{{ currentQuestion.optional ? '( اختیاری )':'' }}</span>

          <b-form-group
            v-if="!end"
            label-cols="12"
            label-size="lg"
          >
            <div v-if="!currentQuestion.answerType">
              <b-form-radio-group
                v-model="selectedAnswer"
                class="d-flex flex-column"
                @change="handleNextStep"
              >
                <b-form-radio
                  v-for="options in currentQuestion.options"
                  :key="options.value"
                  :value="options.value"
                  class="my-2"
                >
                  <span style="font-weight: bold;">
                    {{ options.text }}
                  </span>
                </b-form-radio>
              </b-form-radio-group>
            </div>
            <div v-else-if="currentQuestion.answerType === 'text'">
              <b-form-input
                v-model="selectedAnswer"
                type="text"
                placeholder=""
                class="w-md-50 mx-auto"
              />
              <b-button
                class="w-100 w-md-50 mx-auto mt-1"
                variant="success"
                :disabled="!selectedAnswer?( !currentQuestion.optional) : false "
                @click="handleNextStep"
              >
                بعدی
              </b-button>
            </div>
          </b-form-group>
          <div
            v-if="end"
            cols="4"
          >
            <div>
              <p style="font-weight: bold;">
                {{ getOffer().text }}
              </p>
              <p>
                {{ getOffer().description }}
              </p>
              <p> {{ getOffer().subText }} </p>
            </div>
            <b-row>
              <b-col
                v-for="link in getOffer().links"
                :key="link.title"
                cols="12"
                md="4"
                class="p-1"
              >
                <b-card style="position: relative;box-shadow: 0 0 3px 0 !important;height: 100%;">
                  <h4>{{ link.title }}</h4>
                  <p>{{ link.description }}</p>
                  <b-button
                    style="position: absolute;bottom: 10px;left: 50%; transform: translate(-50%, 0);width: 95%;"
                    variant="success"
                    @click="openLink(link.link)"
                  >مشاهده</b-button>
                </b-card>
              </b-col>
            </b-row>
          </div>
          <div
            v-if="end"
            class="mt-2"
          >
            <validation-observer
              #default="{}"
            >
              <p>شماره موبایل مورد نظر خود را برای دریافت <strong>کد تایید</strong> وارد کنید:</p>
              <b-form @submit.prevent="sendOtpCode()">
                <b-form-group
                  label="شماره موبایل"
                  label-for="mobile-number"
                >
                  <validation-provider
                    #default="{ }"
                    :name="$t('confirm_withdraw_code')"
                    vid="mobile"
                    rules="required"
                  >
                    <b-form-input
                      id="mobile-number"
                      v-model="mobileNumber"
                      type="tel"
                      placeholder="0916XXXXXXX"
                      required
                      class="w-md-50 w-lg-25 mx-auto"
                    />
                  </validation-provider>
                </b-form-group>
                <div
                  class="mx-auto "
                  style="width: 300px;"
                >
                  <b-form-group class="mt-1 ">
                    <vue-recaptcha
                      ref="recaptcha"
                      :sitekey="sitekey"
                      :load-recaptcha-script="true"
                      :theme="$store.state.appConfig.layout.skin == 'dark' ? 'dark' : ''"
                      @expired="onCaptchaExpired"
                      @verify="onVerify"
                    />
                  </b-form-group>
                </div>
                <b-button
                  type="submit"
                  variant="success"
                  :disabled="!recaptcha || !mobileNumber || isVerified"
                >
                  <div>
                    <span v-if="!sendOtpLoading">ارسال کد تایید</span>
                    <b-spinner
                      v-else
                      small
                      size="10"
                      variant="light"
                      type="grow"
                    />
                  </div>
                </b-button>

              </b-form>
            </validation-observer>
            <b-modal
              v-model="otpModal"
              :title="$t('confirm_withdraw')"
              centered
              size="md"
              hide-footer
              no-close-on-backdrop
            >
              <validation-observer
                #default="{invalid}"
              >
                <b-row>
                  <b-col>
                    <b-form-group>
                      <div
                        v-if="mobileNumber"
                        class="my-1"
                      >
                        ایمیل مورد نظر خود را وارد کنید. یک <strong>لینک فعال سازی</strong> برای شما ارسال خواهد شد.
                      </div>
                      <div class="d-flex justify-content-between">
                        <label for="code">{{ $t('email') }}</label>
                      </div>
                      <validation-provider
                        #default="{ errors }"
                        :name="$t('email')"
                        vid="email"
                        rules="required"
                      >
                        <b-input-group>
                          <b-form-input
                            id="email"
                            v-model="email"
                            name="email"
                            placeholder="example@gmail.com"
                            class="mb-1"
                          />
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                    <div
                      v-if="mobileNumber"
                      class="my-1"
                    >
                      لطفا کد ارسال شده به <strong>موبایل</strong> را وارد کنید
                    </div>
                    <b-form
                      class="auth-login-form mb-2 "
                    >

                      <b-form-group>
                        <div class="d-flex justify-content-between">
                          <label for="code">کد</label>
                        </div>
                        <validation-provider
                          #default="{ errors }"
                          :name="$t('code')"
                          vid="code"
                          rules="required"
                        >
                          <b-input-group>
                            <b-form-input
                              id="code"
                              v-model="confirmCode"
                              name="code"
                              placeholder="0000"
                              class="mb-1"
                            />
                          </b-input-group>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-form>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6">
                    <b-button
                      block
                      size="md"
                      variant="warning"
                      :disabled="verifyCounter !== 0"
                      @click="sendOtpCode(true)"
                    >
                      <div v-if="!resendOtpLoading">
                        <span>
                          {{ $t('resend') }}
                        </span>
                        <span v-if="verifyCounter !== 0">( {{ convertSecondsToMinutes(verifyCounter) }} )</span>
                      </div>
                      <b-spinner
                        v-else
                        small
                        size="10"
                        variant="light"
                        type="grow"
                      />
                    </b-button>
                  </b-col>
                  <b-col cols="6">
                    <b-button
                      block
                      size="md"
                      :disabled="invalid || confirmCode.length < 4"
                      variant="success"
                      @click="verify"
                    >
                      <span v-if="!verifyLoading">
                        {{ $t('widrawModal.confirm') }}
                      </span>
                      <b-spinner
                        v-else
                        small
                        size="10"
                        variant="light"
                        type="grow"
                      />
                    </b-button>
                  </b-col>
                </b-row>
              </validation-observer>
            </b-modal>
          </div>
        </div>
      </transition>
    </b-card>
  </b-container>
</template>

<script>
import questionForm from '@/views/logics/profile/questionForm'

export default {
  mixins: [questionForm],
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
</style>
